// Mô-đun B (phán định tổng hợp đa nguồn) · Mô-đun C (quản lý chất lượng tự động HITL)
const moduleb = {
  nav: {
    brandTitle: 'Mô-đun B · Phán định lỗi tổng hợp 3 nguồn',
    brandSub: 'Quy trình · Thị giác · Nhiệt ảnh',
    steps: {
      sync: { title: 'Đồng bộ shot-sản phẩm', desc: 'Shot-Product Sync' },
      features: { title: 'Trích xuất & đối sánh đặc trưng', desc: 'Feature Extraction' },
      fusion: { title: 'Tổng hợp trọng số 3 nguồn', desc: 'Triple Fusion' },
      judgment: { title: 'Phán định lỗi tổng hợp', desc: 'Defect Judgment' },
    },
  },
  common: {
    selectProduct: 'Chọn sản phẩm',
    resultOk: 'Đạt',
    resultNg: 'Lỗi',
    judgeOk: 'Bình thường',
    shotId: 'Mã shot',
    productId: 'Mã sản phẩm',
    time: 'Thời gian',
    unitCount: '',
    newBadge: 'MỚI',
    tempSensitive: 'Nhạy nhiệt',
    sources: {
      process: 'Quy trình',
      vision: 'Thị giác',
      thermal: 'Nhiệt ảnh',
      temperature: 'Nhiệt độ',
    },
  },
  defects: {
    warpage: 'Cong vênh',
    shrinkage: 'Co ngót',
    dimension: 'Kích thước',
    surface: 'Lỗi bề mặt',
    shortShot: 'Thiếu nhựa',
    flash: 'Bavia (Flash)',
  },
  sync: {
    subtitle: 'Xác định dữ liệu quy trình, thị giác và nhiệt ảnh có thuộc cùng một sản phẩm hay không (1 shot = 1 sản phẩm) bằng bộ Shot-Product Sync',
    meta: 'Dây chuyền: Máy ép #1 · CAV-A · Thời gian thực',
    timelineTitle: 'Dòng thời gian đối sánh cùng sản phẩm',
    timelineHint: 'Đường đứt dọc = 3 nguồn được đối sánh cùng một sản phẩm',
    tableTitle: 'Tình trạng đối sánh shot-sản phẩm gần đây',
    confidence: 'Độ tin cậy đối sánh',
    judgement: 'Kết quả',
    detailTitle: 'Chi tiết đối sánh',
    refLabel: 'Sản phẩm đã đối sánh · Thời điểm chuẩn',
    sourceKeyLabel: 'Khóa nhận dạng theo nguồn / Độ tin cậy',
    detailNote: 'So sánh khóa nhận dạng và thời điểm của 3 nguồn để xác định cùng một sản phẩm. Nếu bất kỳ nguồn nào không khớp, shot đó bị loại khỏi bước tổng hợp.',
    drilldown: 'Phân tích tổng hợp cho {product}',
    drilldownBlocked: 'Đối sánh thất bại · Không thể phân tích tổng hợp',
    matched: 'khớp',
    unmatched: 'Không khớp',
    missing: '(thiếu)',
    stats: {
      totalShots: 'Tổng số shot',
      matchRate: 'Tỷ lệ đối sánh',
      confidence: 'Độ tin cậy trung bình',
      mismatch: 'Số ca không khớp',
    },
    status: {
      match: 'Khớp',
      check: 'Cần kiểm tra',
      mismatch: 'Không khớp',
    },
  },
  features: {
    subtitle: 'Trích xuất đặc trưng của 3 nguồn (chuỗi thời gian · hình dạng · trường nhiệt) từ một shot đã đồng bộ và đối sánh về cùng hệ tọa độ sản phẩm',
    meta: 'Shot mục tiêu',
    selectShot: 'Chọn shot',
    panelProcess: 'Chuỗi thời gian · Quy trình (Sₚ)',
    panelVision: 'Hình dạng · Thị giác (Sᵥ)',
    panelThermal: 'Trường nhiệt · Nhiệt ảnh (Sₜ)',
    imagePlaceholder: 'Ảnh ngoại quan sản phẩm',
    extracted: 'Đặc trưng trích xuất',
    registrationTitle: 'Đối sánh (Registration) — căn chỉnh ROI thị giác và tọa độ trường nhiệt về cùng lưới sản phẩm',
    visionRoi: 'ROI thị giác',
    thermalHotspot: 'Điểm nóng nhiệt',
    regAccuracy: 'Độ chính xác đối sánh',
    offsetX: 'Độ lệch (X)',
    offsetY: 'Độ lệch (Y)',
    legendVision: 'Tọa độ hình dạng thị giác',
    legendThermal: 'Tọa độ trường nhiệt',
    legend: {
      pressure: 'Áp ép (MPa)',
      velocity: 'Tốc độ ép (mm/s)',
      holding: 'Giữ áp (MPa)',
    },
    process: {
      peakPressure: 'Áp ép đỉnh',
      holdTime: 'Thời gian giữ áp',
      fillTime: 'Thời gian điền đầy',
      chargeTime: 'Thời gian cấp liệu',
      maxSpeed: 'Tốc độ ép tối đa',
      cushion: 'Lượng đệm',
    },
    vision: {
      edgeDensity: 'Mật độ biên',
      defectCandidates: 'Vùng nghi ngờ lỗi',
      contourCompleteness: 'Độ hoàn chỉnh đường viền',
      roiAreaRatio: 'Tỷ lệ diện tích ROI',
      roiShape: 'ROI-Hình dạng',
      roiDefect: 'Nghi ngờ lỗi',
    },
    thermal: {
      maxTemp: 'Nhiệt độ cao nhất',
      avgTemp: 'Nhiệt độ trung bình',
      hotspot: 'Tọa độ điểm nóng',
      stdDev: 'Độ lệch nhiệt (σ)',
    },
  },
  fusion: {
    subtitle: 'Thị giác, quy trình và nhiệt độ mỗi nguồn tự phán định đạt/lỗi, sau đó tổng hợp bằng trọng số cố định định sẵn để tính điểm tổng hợp S (tổng hợp bền vững dạng mô-đun)',
    formulaNote: 'Thành phần γ (nhiệt ảnh) được bổ sung mới để phán định trực tiếp các lỗi nhạy nhiệt',
    modalityTitle: 'Phán định đạt/lỗi theo từng nguồn · Trọng số cố định',
    fixedWeight: 'Trọng số cố định',
    weightSum: 'Trọng số là giá trị cố định định sẵn (α 35% · β 35% · γ 30%)',
    weightSumNote: '— chỉ tự chuẩn hóa lại khi thiếu nguồn',
    contribTitle: 'Mức đóng góp (trọng số × điểm)',
    donutLabel: 'Tổng hợp S',
    resultTitle: 'Điểm tổng hợp cuối S',
    thresholdLabel: 'Ngưỡng phán định',
    verdictNg: 'S ≥ ngưỡng → ứng viên lỗi (NG)',
    verdictOk: 'S < ngưỡng → ứng viên đạt (OK)',
    next: 'Sang phán định tổng hợp cho {product}',
    degradeTitle: 'Graceful Degradation — tự chuyển đổi khi thiếu nguồn',
    activeCount: 'Tổng hợp {n} nguồn',
    stateActive: 'Hoạt động',
    stateMissing: 'Thiếu',
    degradeBadge: 'Thiếu nhiệt độ → tự chuyển sang tổng hợp 2 nguồn (γ=0, chuẩn hóa lại α·β)',
    degradationNote: 'Khi thiếu dữ liệu nhiệt độ, đặt γ=0 và chuẩn hóa lại α·β sao cho tổng bằng 1, tự động chuyển sang tổng hợp 2 nguồn.',
  },
  judgment: {
    subtitle: 'Dùng kết quả tổng hợp 3 nguồn (S) từ BƯỚC 3 để phán định đạt/lỗi cuối cùng và loại lỗi, đồng thời trình bày căn cứ (nguồn đóng góp)',
    fusionScore: 'Điểm tổng hợp S',
    confidence: 'Độ tin cậy',
    threshold: 'Ngưỡng {value}',
    thresholdOver: 'vượt → phán định lỗi',
    thresholdUnder: 'dưới → phán định đạt',
    defectTypeTitle: 'Phân loại loại lỗi',
    legendOver: 'Loại vượt ngưỡng',
    contribTitle: 'Căn cứ phán định · Nguồn đóng góp',
    tempLed: 'Nhạy nhiệt dẫn dắt',
    noteHead: 'Phán định này do {label} đóng góp {percent}%,',
    noteThermal: 'nhiệt ảnh dẫn dắt việc phát hiện lỗi nhạy nhiệt (cong vênh, co ngót).',
    noteOther: 'tín hiệu {label} dẫn dắt phán định.',
    annotationTitle: 'Chú thích vùng lỗi',
    productImage: 'Ảnh sản phẩm',
    annotationNg: 'Tự động hiển thị vùng nghi ngờ lỗi',
    annotationOk: 'Không có vùng bất thường (đạt)',
    historyTitle: 'Lịch sử phán định gần đây',
    verdict: 'Phán định',
    defectType: 'Loại lỗi',
    contribModality: 'Nguồn đóng góp',
    kpi: {
      f1: 'F1 tổng hợp',
      recall: 'Recall nhạy nhiệt',
      total: 'Số phán định tích lũy',
      rate: 'Tỷ lệ lỗi',
    },
    badge: {
      ok: 'Đạt (OK)',
      ng: 'Lỗi (NG)',
    },
    contrib: {
      thermal: 'Nhiệt độ (Sₜ)',
      vision: 'Thị giác (Sᵥ)',
      process: 'Quy trình (Sₚ)',
    },
    annotations: {
      warpage: 'Nghi ngờ cong vênh',
      shrinkage: 'Nghi ngờ co ngót',
    },
  },
};

const modulec = {
  nav: {
    brandTitle: 'Mô-đun C · Quản lý chất lượng tự động HITL có yếu tố nhiệt độ',
    brandSub: 'AI khuyến nghị → người vận hành phê duyệt → 3 lớp bảo vệ (chặn ngưỡng · hoàn tác · in-silico)',
    steps: {
      recommend: { title: 'Tạo & phê duyệt khuyến nghị', desc: 'Recommend & Approve' },
      safeguard: { title: 'Bảo vệ an toàn', desc: 'Safeguard' },
    },
  },
  common: {
    countSuffix: '{n}',
    tempTag: 'Nhiệt',
  },
  params: {
    injectionPressure: 'Áp suất ép',
    injectionSpeed: 'Tốc độ ép',
    holdingPressure: 'Áp giữ',
    moldTemp: 'Nhiệt độ khuôn',
    coolingTime: 'Thời gian làm mát',
  },
  paramStatus: {
    normal: 'Bình thường',
    warn: 'Cảnh báo',
    exceed: 'Vượt ngưỡng',
  },
  recCaseStatus: {
    pending: 'Chờ phê duyệt',
    approved: 'Đã phê duyệt',
  },
  approvalStatus: {
    pending: 'Chờ phê duyệt',
    approved: 'Đã phê duyệt',
    rejected: 'Đã từ chối',
  },
  overallStatus: {
    safe: 'An toàn (bình thường)',
    blocked: 'Đã chặn',
    rollbackWait: 'Chờ hoàn tác',
  },
  changeLogStatus: {
    applied: 'Đã áp dụng',
    rolledback: 'Đã hoàn tác',
    blocked: 'Đã chặn',
  },
  worker: {
    name: 'Kim Hyunsoo',
    name2: 'Lee Jungmin',
    shift: 'Ca ngày A',
    role: 'Phụ trách quy trình',
    aiAuto: 'AI tự động',
  },
  timeline: {
    requested: { label: 'Đã yêu cầu phê duyệt', desc: 'AI tạo điều kiện khuyến nghị · yêu cầu phê duyệt' },
    reviewing: { label: 'Người vận hành đang xem xét', desc: 'Kim Hyunsoo (Ca ngày A) đang xem xét' },
    decision: { label: 'Phê duyệt / Từ chối', desc: 'Chờ quyết định cuối của người vận hành' },
    safeguard: { label: 'Kiểm chứng bảo vệ', desc: 'Chuyển sang bước bảo vệ khi được phê duyệt' },
  },
  modal: {
    changeSummary: 'Tóm tắt thay đổi ({n} thông số)',
    param: 'Thông số',
    current: 'Giá trị hiện tại',
    recommended: 'Giá trị khuyến nghị',
    worker: 'Người phụ trách',
    confirmApply: 'Xác nhận & áp dụng',
    cancel: 'Hủy',
  },
  recommend: {
    title: 'Tạo điều kiện khuyến nghị',
    subtitle: 'AI tự động khuyến nghị điều kiện quy trình tối ưu dựa trên kết quả phán định tổng hợp của Mô-đun B (lỗi và nguyên nhân)',
    meta: 'Shot mục tiêu',
    listTitle: 'Danh sách khuyến nghị',
    paramTitle: 'Điều kiện khuyến nghị · Hiện tại → Khuyến nghị',
    expectedReduction: 'Mức giảm lỗi dự kiến',
    confidence: 'Độ tin cậy khuyến nghị',
    approvedBanner: 'Đã phê duyệt khuyến nghị — chuyển sang bước kiểm chứng bảo vệ',
    approvedShort: 'Đã phê duyệt khuyến nghị',
    goSafeguard: 'Sang bước bảo vệ',
    approveHint: 'Xem xét điều kiện khuyến nghị đã chọn rồi phê duyệt. Khi được phê duyệt, điều kiện sẽ áp dụng tại hiện trường sau bước xác nhận.',
    approveBtn: 'Phê duyệt khuyến nghị',
    modalTitle: 'Xác nhận áp dụng điều kiện khuyến nghị',
    modalMessage: 'Áp dụng điều kiện khuyến nghị của {product} ({shot}) tại hiện trường?',
    modalWarning: 'Khi áp dụng sẽ phản ánh ngay vào quy trình. Sau đó có thể hoàn tác ở bước bảo vệ.',
    cols: {
      param: 'Thông số quy trình',
      current: 'Giá trị hiện tại',
      recommended: 'Giá trị khuyến nghị',
      delta: 'Mức thay đổi (Δ)',
      range: 'Dải ngưỡng',
      status: 'Trạng thái',
    },
    notes: {
      rec2048: 'Tăng nhiệt độ khuôn và rút ngắn thời gian làm mát dự kiến giảm trực tiếp các lỗi nhạy nhiệt (cong vênh, co ngót).',
      rec2043: 'Tăng áp suất ép và áp giữ dự kiến ổn định lỗi kích thước (do quy trình chi phối).',
      rec2041: 'Tăng nhiệt độ khuôn dẫn dắt việc giảm lỗi nhạy nhiệt (cong vênh). Cần lưu ý vì gần ranh giới ngưỡng.',
    },
  },
  safeguard: {
    subtitle: '3 lớp bảo vệ đảm bảo an toàn trước và sau khi áp dụng điều kiện đã phê duyệt tại hiện trường (chặn vượt ngưỡng · hoàn tác · kiểm chứng trước in-silico)',
    guard1: '① Tự động chặn vượt ngưỡng',
    guard2: '② Hoàn tác · Lịch sử thay đổi',
    guard3: '③ Kiểm chứng trước in-silico',
    blocked: 'Đã chặn',
    normal: 'Bình thường',
    guard1NoteBlocked: 'Phát hiện giá trị khuyến nghị nằm ngoài dải ngưỡng nên việc áp dụng đã bị chặn tự động.',
    guard1NoteOk: 'Tất cả giá trị khuyến nghị nằm trong dải ngưỡng nên có thể áp dụng.',
    rollbackBtn: 'Hoàn tác về điều kiện trước',
    rollbackRequested: 'Đã yêu cầu hoàn tác',
    passed: 'Đạt',
    failed: 'Không đạt',
    beforeExpected: 'Dự kiến trước khi áp dụng',
    afterExpected: 'Dự kiến sau mô phỏng',
    twinVerified: 'Đã kiểm chứng mô phỏng bằng digital twin',
    silicoNote: 'Điều khiển hoàn toàn tự động chỉ thực hiện đến bước kiểm chứng ảo bằng digital twin; việc áp dụng trực tiếp tại hiện trường bắt buộc phải có phê duyệt của người vận hành.',
    verifyTitle: 'Kiểm chứng xu hướng tỷ lệ lỗi trước/sau khi áp dụng',
    defectRate: 'Tỷ lệ lỗi',
    applied: 'Áp dụng khuyến nghị',
    reduction: 'Mức giảm tỷ lệ lỗi',
    significance: 'Ý nghĩa thống kê',
    cumulativeShots: 'Số shot áp dụng tích lũy',
    hourLabel: '{h}:00',
    rollbackTitle: 'Hoàn tác về điều kiện trước',
    rollbackMessage: 'Hủy điều kiện đang áp dụng và khôi phục điều kiện quy trình trước đó?',
    rollbackWarning: 'Khi hoàn tác, điều kiện khuyến nghị hiện tại sẽ được gỡ ngay và quay về giá trị trước đó.',
    rollbackConfirm: 'Thực hiện hoàn tác',
    cols: {
      time: 'Thời gian',
      param: 'Thông số',
      change: 'Thay đổi',
      actor: 'Người áp dụng',
      status: 'Trạng thái',
    },
  },
};

const moduleI18n = { moduleb, modulec };

export default moduleI18n;
